module.exports = __webpack_public_path__ + "00db7b48aae2910e47a146be7df1374c.png";